import { z } from 'zod'
import { ValidationMessageKeys } from './translation-keys'
import i18n from '../i18n'

z.setErrorMap((issue, ctx) => {
  if (issue.code === z.ZodIssueCode.too_small) {
    if (issue.type === 'number') {
      return { message: i18n.t(ValidationMessageKeys.min, { value: issue.minimum }) }
    }
    if (issue.type === 'string') {
      return { message: i18n.t(ValidationMessageKeys.lengthMin, { value: issue.minimum }) }
    }
    if (issue.type === 'array') {
      return { message: i18n.t(ValidationMessageKeys.arrayMin, { value: issue.minimum }) }
    }
  }

  if (issue.code === z.ZodIssueCode.too_big) {
    if (issue.type === 'number') {
      return { message: i18n.t(ValidationMessageKeys.max, { value: issue.maximum }) }
    }
    if (issue.type === 'string') {
      return { message: i18n.t(ValidationMessageKeys.lengthMax, { value: issue.maximum }) }
    }
    if (issue.type === 'array') {
      return { message: i18n.t(ValidationMessageKeys.arrayMax, { value: issue.maximum }) }
    }
  }

  if (issue.code === z.ZodIssueCode.invalid_type) {
    if (issue.expected === 'number') {
      return { message: i18n.t(ValidationMessageKeys.number) }
    }
    if (issue.expected === 'integer') {
      return { message: i18n.t(ValidationMessageKeys.integer) }
    }
  }

  return { message: ctx.defaultError }
})
